export default __webpack_public_path__ + "static/O0277-9ee18c64ba7f46c6d3532c7b33be0510.png";